import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";

/*
 *  Home Concerns Section
 *    scripts for automatic vertical scrolling list
 *
 *  Version:
 *    1.0.0 - 2021/06/04
 */
// Selectors
var SELECTOR_CONCERNS_CONTAINER = '[data-home-concerns]';
var SELECTOR_CONCERNS_CAROUSEL = '[data-concerns-carousel]';
document.querySelectorAll(SELECTOR_CONCERNS_CONTAINER).forEach(function (section) {
  var carousel = section.querySelector(SELECTOR_CONCERNS_CAROUSEL);
  var direction = 'down';
  if (!carousel) return;
  /**
   * Function that infinitely scrolls to bottom of the scroll container
   *  then reverses direction 
   */

  var infScroll = function infScroll() {
    // Calculate the point to reverse the scroll direction
    var carouselScrollHeight = carousel.scrollHeight;
    var carouselVisibleHeight = carousel.offsetHeight;
    var returnPoint = carouselScrollHeight - carouselVisibleHeight;
    if (!carousel) return; // Scroll down if there's space to scroll

    if (carousel.scrollTop < returnPoint && direction === 'down') {
      carousel.scrollTop += 1; // Reached the end? Turn back up

      if (carousel.scrollTop === returnPoint) {
        direction = 'up';
      }
    }

    if (direction === 'up') {
      carousel.scrollTop -= 1; // Reached the start? Go back down

      if (carousel.scrollTop <= 0) {
        direction = 'down';
      }
    }
  }; // Initialize scrolling


  var scroller = setInterval(infScroll, 30); // Stop scrolling on mouseover

  carousel.addEventListener('mouseover', function () {
    clearInterval(scroller);
  }); // Resume scrolling on mouseleave

  carousel.addEventListener('mouseleave', function () {
    scroller = setInterval(infScroll, 30);
  });
});